import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API_BASE from "../config/api";
import Swal from "sweetalert2";


function Navbar() {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const saved = localStorage.getItem("user");
        if (saved) setUser(JSON.parse(saved));
    }, []);

    const handleLogout = () => {
        console.log("LOGOUT CLICKED");   // 🔥 ADD THIS
        localStorage.removeItem("user");
        window.location.href = "/";       // full reload
    };

    const [show, setShow] = useState(false);
    const [agents, setAgents] = useState([]);
    const [selectedAgent, setSelectedAgent] = useState(null);

    const [mobile, setMobile] = useState("");
    const [callStep, setCallStep] = useState(1);
    const [businessName, setBusinessName] = useState("");
    const [imgLoaded, setImgLoaded] = useState(false);

    const [countryMenu, setCountryMenu] = useState(false);



    const [showLeadsModal, setShowLeadsModal] = useState(false);
    const [leadStep, setLeadStep] = useState(1);
    const [leadMobile, setLeadMobile] = useState("");
    const [leadRequirement, setLeadRequirement] = useState("");
    const [leadId, setLeadId] = useState(null);
    const [leadLoading, setLeadLoading] = useState(false);
    const [showAdvertiseModal, setShowAdvertiseModal] = useState(false);
    const [showAdModal, setShowAdModal] = useState(false);
    const [adLoading, setAdLoading] = useState(false);
    useEffect(() => {
        fetchAgents();
    }, []);

    const fetchAgents = async () => {
        try {
            const res = await fetch(`${API_BASE}/api/support-agents.php`);
            const data = await res.json();

            if (data.success && Array.isArray(data.data)) {
                setAgents(data.data);

                // 🔥 PRELOAD IMAGES
                data.data.forEach(agent => {
                    preloadImage(agent.photo || getFallbackImage(agent.gender));
                });
            }
        } catch (e) {
            console.error(e);
        }
    };

    const getFallbackImage = (gender) => {
        return gender === "male"
            ? "/call_center_male.jpg"
            : "/Call_center_female.jpg";
    };
    const preloadImage = (src) => {
        const img = new Image();
        img.src = src;
    };

    const [country, setCountry] = useState({
        code: "+977",
        flag: "🇳🇵",   // ✅ EMOJI FLAG
        maxLength: 10
    });


    const CancelBtn = () => (
        <button
            className="btn btn-outline-secondary w-100 mt-2"
            onClick={closeModal}
        >
            Cancel
        </button>
    );

    const openModal = () => {
        if (!agents.length) return;

        const random = agents[Math.floor(Math.random() * agents.length)];
        setSelectedAgent(random);

        setMobile("");
        setBusinessName("");
        setCallStep(1);

        // 🔥 Small delay for smoothness
        setTimeout(() => setShow(true), 50);
    };



    const saveEnquiry = async (type) => {
        if (!mobile) return;

        try {
            await fetch(`${API_BASE}/api/save-enquiry-talktous.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    mobile,
                    country_code: country.code,
                    business_name: businessName || null,
                    enquiry_type: type,
                    agent_name: selectedAgent?.name || null
                })
            });
        } catch (err) {
            console.error("Enquiry save failed", err);
        }
    };
    const closeModal = () => {
        saveEnquiry("closed");   // ✅ SAVE EVEN IF CLOSED
        setShow(false);
    };
    const [showAgentModal, setShowAgentModal] = useState(false);

    const [agentForm, setAgentForm] = useState({
        full_name: "",
        mobile: "",
        email: "",
        city: "",
        experience: ""
    });
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        }
    });

    const handleLeadContinue = async () => {
        if (leadMobile.length !== 10) {
            Toast.fire({
                icon: "warning",
                title: "Please enter valid mobile number"
            });
            return;
        }

        const id = await createLead("continue");
        if (!id) {
            Toast.fire({
                icon: "error",
                title: "Could not create lead"
            });
            return;
        }

        Toast.fire({
            icon: "success",
            title: "Mobile verified"
        });

        setLeadId(id);
        setLeadStep(2); // go to requirement step
    };

    const createLead = async () => {
        try {
            setLeadLoading(true);
            const res = await fetch(`${API_BASE}/api/create-lead.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    mobile: leadMobile,
                    country_code: "+977"
                })
            });

            const data = await res.json();
            if (data.success) {
                setLeadId(data.lead_id);
                setLeadStep(2);
            }
        } finally {
            setLeadLoading(false);
        }
    };

    const submitRequirement = async () => {
        if (!leadRequirement.trim()) {
            Toast.fire({
                icon: "warning",
                title: "Please enter your requirement"
            });
            return;
        }

        try {
            const res = await fetch(`${API_BASE}/api/lead-event.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    lead_id: leadId,
                    event_type: "enquiry_sent",
                    reference_id: leadRequirement
                })
            });

            if (!res.ok) throw new Error("Network error");

            const data = await res.json();
            if (!data.success) throw new Error("Save failed");

            Toast.fire({
                icon: "success",
                title: "Lead generated successfully"
            });

            // reset everything
            setTimeout(() => {
                setShowLeadsModal(false);
                setLeadStep(1);
                setLeadMobile("");
                setLeadRequirement("");
                setLeadId(null);
            }, 500);

        } catch (err) {
            console.error(err);
            Toast.fire({
                icon: "error",
                title: "Something went wrong"
            });
        }
    };

    const [adForm, setAdForm] = useState({
        business_name: "",
        mobile: "",
        city: "",
        category: "",
        budget_range: ""
    });
    const submitAdvertisement = async () => {
        if (!adForm.business_name || !adForm.mobile || !adForm.city) {
            Toast.fire({
                icon: "warning",
                title: "Please fill all required fields"
            });
            return;
        }

        if (adForm.mobile.length !== 10) {
            Toast.fire({
                icon: "warning",
                title: "Enter valid 10 digit mobile number"
            });
            return;
        }

        try {
            setAdLoading(true);

            const res = await fetch(`${API_BASE}/api/save-advertisement.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    business_name: adForm.business_name,
                    mobile: adForm.mobile,
                    city: adForm.city,
                    category: adForm.category,
                    budget_range: adForm.budget_range,
                    source: "navbar"
                })
            });

            if (!res.ok) throw new Error("Network error");

            const data = await res.json();

            if (!data.success) throw new Error("DB error");

            Toast.fire({
                icon: "success",
                title: "Advertisement request submitted"
            });

            // RESET + CLOSE
            setTimeout(() => {
                setShowAdModal(false);
                setAdForm({
                    business_name: "",
                    mobile: "",
                    city: "",
                    category: "",
                    budget_range: ""
                });
            }, 500);

        } catch (err) {
            console.error(err);
            Toast.fire({
                icon: "error",
                title: "Something went wrong"
            });
        } finally {
            setAdLoading(false);
        }
    };

    return (
        <>
            <nav className="navbar navbar-expand-lg bg-white shadow-sm py-3 sticky-top">
                <div className="container">

                    {/* Logo */}
                    <Link to="/" className="navbar-brand d-flex align-items-center">
                        <img
                            src="/logo.png"
                            alt="Dial Nepal Logo"
                            style={{ width: "160px", marginRight: "49px" }}
                        />
                    </Link>

                    {/* Mobile Toggle */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#mainNavbar"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="mainNavbar">

                        {/* CENTER MENU */}
                        <ul className="navbar-nav mx-auto mb-2 mb-lg-0 pl-2">
                            <li className="nav-item px-2">
                                <Link className="nav-link fw-semibold text-dark" style={{ fontSize: "17px" }} to="/">Home</Link>
                            </li>

                            <li className="nav-item mt-1">
                                <button
                                    className="nav-link fw-semibold text-dark btn btn-link p-0"
                                    onClick={() => setShowLeadsModal(true)}
                                >
                                    <span style={{ position: "relative", display: "inline-block" }}>
                                        Leads
                                        <span
                                            style={{
                                                position: "absolute",
                                                width: "5px",
                                                height: "5px",
                                                background: "red",
                                                borderRadius: "50%",
                                                top: "1px",
                                                right: "-6px"
                                            }}
                                        />
                                    </span>
                                </button>

                            </li>




                            <li className="nav-item mt-1">
                                <button
                                    className="nav-link fw-semibold text-dark btn btn-link p-0"
                                    onClick={() => setShowAdModal(true)}
                                >
                                    Advertise
                                </button>
                            </li>

                            <li className="nav-item mt-1">
                                <button
                                    className="nav-link fw-semibold text-dark btn btn-link p-0"
                                    onClick={() => setShowAgentModal(true)}
                                >
                                    Become An Agent
                                </button>

                            </li>
                        </ul>



                        {/* RIGHT SIDE BUTTONS */}
                        <div className="d-flex align-items-center gap-2 ms-lg-3 mt-3 mt-lg-0">

                            {/* 1️⃣ Free Listing Button */}
                            <Link to="/add-listing" className="fb btn  px-3 d-flex align-items-center" style={{
                                backgroundColor: "#0076d7",   // faint blue
                                color: "#ffffff",             // white text
                                border: "1px solid #6ea8fe"
                            }}>
                                <i className="bi bi-plus-lg me-1"></i>
                                Free Listing

                                {/* 🏷️ Small Tag Badge like JD business name */}
                                <span className="badge bg-warning text-dark ms-2" style={{ fontSize: "10px" }}>
                                    New
                                </span>
                            </Link>


                            {/* BUTTON */}
                            <button
                                className="btn btn-success px-3"
                                onClick={openModal}   // ✅ THIS IS THE KEY
                            >
                                <i className="bi bi-telephone-fill me-1"></i>
                                Talk to Us
                            </button>


                            {/* MODAL */}
                            {show && (
                                <div
                                    className="modal fade show"
                                    style={{ display: "block", background: "rgba(0,0,0,.5)" }}
                                >
                                    <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content" style={{ borderRadius: 10 }}>
                                            {/* HEADER */}
                                            <div
                                                className="text-dark text-center p-3"
                                                style={{
                                                    background: "linear-gradient(135deg,rgb(192 223 248))",

                                                    borderTopLeftRadius: 6,   // ✅ curve top-left
                                                    borderTopRightRadius: 6,  // ✅ curve top-right
                                                }}
                                            >
                                                <h5 className="mb-0">
                                                    Talk to Our Support Expert
                                                </h5>
                                            </div>



                                            {/* BODY */}
                                            <div className="p-4 text-center">

                                                {/* ================= STEP 1 ================= */}
                                                {callStep === 1 && selectedAgent && (
                                                    <>
                                                        <div className="position-relative d-inline-block mb-3">
                                                            {!imgLoaded && (
                                                                <div className="agent-skeleton"></div>
                                                            )}

                                                            <img
                                                                src={selectedAgent?.photo || getFallbackImage(selectedAgent?.gender)}
                                                                onLoad={() => setImgLoaded(true)}
                                                                onError={(e) => {
                                                                    e.currentTarget.onerror = null;
                                                                    e.currentTarget.src = getFallbackImage(selectedAgent?.gender);
                                                                }}
                                                                className={`agent-avatar ${imgLoaded ? "show" : "hide"}`}
                                                                alt={selectedAgent?.name}
                                                            />
                                                        </div>



                                                        <h6 className="fw-bold mb-1">
                                                            {selectedAgent.name} will assist you
                                                        </h6>

                                                        <h6 className="fw-bold mb-1">
                                                            Talk to {selectedAgent.name}
                                                        </h6>

                                                        <p className="text-muted small mb-3">
                                                            Free expert call · No spam
                                                        </p>


                                                        {/* PHONE + BUTTON */}
                                                        <div className="d-flex align-items-center border rounded-3 overflow-hidden mb-3">

                                                            {/* NEPAL FLAG + CODE (FIXED) */}
                                                            <div className="d-flex align-items-center px-3 gap-2 border-end">
                                                                <img
                                                                    src="/np.svg"
                                                                    alt="Nepal"
                                                                    width="22"
                                                                    height="16"
                                                                />
                                                                <span className="fw-semibold">+977</span>
                                                            </div>

                                                            {/* INPUT */}
                                                            <input
                                                                type="text"
                                                                className="form-control border-0"
                                                                placeholder="Enter Mobile No."
                                                                maxLength={10}
                                                                value={mobile}
                                                                onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                                                            />


                                                        </div>







                                                        <div className="d-flex gap-2">
                                                            <button
                                                                className="btn jd-call-btn flex-grow-1"
                                                                onClick={() => {
                                                                    if (mobile.length !== country.maxLength)
                                                                        return alert("Enter valid 10 digit mobile number");
                                                                    saveEnquiry("call_now");   // ✅ SAVE
                                                                    setCallStep(2);
                                                                    setTimeout(() => setCallStep(3), 3000);
                                                                }}
                                                            >
                                                                Call Now
                                                            </button>

                                                            <button
                                                                className="btn btn-outline-secondary flex-grow-1"
                                                                onClick={closeModal}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>

                                                    </>
                                                )}

                                                {/* ================= STEP 2 ================= */}
                                                {callStep === 2 && (
                                                    <>
                                                        <h6 className="mb-3">📞 Incoming voice call</h6>

                                                        <div className="position-relative d-inline-block mb-3">
                                                            {!imgLoaded && (
                                                                <div className="agent-skeleton"></div>
                                                            )}

                                                            <img
                                                                src={selectedAgent?.photo || getFallbackImage(selectedAgent?.gender)}
                                                                onLoad={() => setImgLoaded(true)}
                                                                onError={(e) => {
                                                                    e.currentTarget.onerror = null;
                                                                    e.currentTarget.src = getFallbackImage(selectedAgent?.gender);
                                                                }}
                                                                className={`agent-avatar ${imgLoaded ? "show" : "hide"}`}
                                                                alt={selectedAgent?.name}
                                                            />
                                                        </div>


                                                        <p className="text-primary fw-semibold">
                                                            Connecting {selectedAgent?.name}...
                                                        </p>
                                                        <CancelBtn />
                                                    </>
                                                )}

                                                {/* ================= STEP 3 ================= */}
                                                {callStep === 3 && (
                                                    <>
                                                        <h6 className="text-danger mb-2">Agent Busy</h6>

                                                        <p className="small">
                                                            All our advisors are currently busy.<br />
                                                            We will call you back shortly on <b>{mobile}</b>
                                                        </p>

                                                        <input
                                                            className="form-control my-3"
                                                            placeholder="Enter Business Name"
                                                            value={businessName}
                                                            onChange={(e) => setBusinessName(e.target.value)}
                                                        />

                                                        <div className="d-flex gap-2">
                                                            <button
                                                                className="btn btn-success flex-grow-1"
                                                                onClick={() => {
                                                                    if (!businessName)
                                                                        return alert("Enter business name");
                                                                    setCallStep(4);
                                                                }}
                                                            >
                                                                Submit
                                                            </button>

                                                            <button
                                                                className="btn btn-outline-secondary flex-grow-1"
                                                                onClick={closeModal}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>

                                                    </>
                                                )}

                                                {/* ================= STEP 4 ================= */}
                                                {callStep === 4 && (
                                                    <>
                                                        <div className="text-success fs-1 mb-2">✔</div>

                                                        <h6>Thank you for sharing your business name</h6>

                                                        <p className="small">
                                                            We will call you back shortly on <b>{mobile}</b>
                                                        </p>

                                                        <button
                                                            className="btn btn-outline-secondary w-100"
                                                            onClick={closeModal}
                                                        >
                                                            Close
                                                        </button>

                                                    </>
                                                )}

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )}




                            {/* BEFORE LOGIN → Show Login Button */}
                            {!user && (
                                <Link to="/login" className="btn btn-outline-primary px-3">
                                    <i className="bi bi-box-arrow-in-right me-1"></i>
                                    Login
                                </Link>
                            )}

                            {/* AFTER LOGIN */}
                            {user && (
                                <div className="dropdown">
                                    <button
                                        className="user-btn dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                    >
                                        <i className="bi bi-person-circle me-2"></i>
                                        {user.fullname}
                                    </button>

                                    <ul className="dropdown-menu dropdown-menu-end shadow-sm">
                                        <li>
                                            <span className="dropdown-item-text small text-muted">
                                                Welcome
                                            </span>
                                        </li>

                                        <li>
                                            <span className="dropdown-item-text fw-semibold">
                                                {user.fullname}
                                            </span>
                                        </li>

                                        <li><hr className="dropdown-divider" /></li>

                                        <li>
                                            <Link
                                                className="dropdown-item"
                                                to={`/admin?userid=${user.personaluid}`}
                                            >
                                                <i className="bi bi-grid me-2"></i>
                                                Admin Panel
                                            </Link>
                                        </li>

                                        <li>
                                            <button
                                                className="dropdown-item text-danger"
                                                onClick={handleLogout}
                                            >
                                                <i className="bi bi-box-arrow-right me-2"></i>
                                                Logout
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>

                        {showAgentModal && (
                            <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,.5)" }}>
                                <div className="modal-dialog modal-dialog-centered">
                                    <div className="modal-content rounded-4">

                                        {/* HEADER */}
                                        <div className="modal-header bg-light" style={{
                                            background: "linear-gradient(135deg,rgb(192 223 248))",
                                        }}>
                                            <h5 className="modal-title">Become a Dial Nepal Agent</h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                onClick={() => setShowAgentModal(false)}
                                            />


                                        </div>

                                        {/* BODY */}
                                        <div className="modal-body">

                                            <input
                                                className="form-control mb-2"
                                                placeholder="Full Name *"
                                                value={agentForm.full_name}
                                                onChange={e => setAgentForm({ ...agentForm, full_name: e.target.value })}
                                            />

                                            <input
                                                className="form-control mb-2"
                                                placeholder="Mobile Number *"
                                                maxLength={10}
                                                value={agentForm.mobile}
                                                onChange={e => setAgentForm({ ...agentForm, mobile: e.target.value.replace(/\D/g, "") })}
                                            />

                                            <input
                                                className="form-control mb-2"
                                                placeholder="Email (optional)"
                                                value={agentForm.email}
                                                onChange={e => setAgentForm({ ...agentForm, email: e.target.value })}
                                            />

                                            <input
                                                className="form-control mb-2"
                                                placeholder="City *"
                                                value={agentForm.city}
                                                onChange={e => setAgentForm({ ...agentForm, city: e.target.value })}
                                            />

                                            <select
                                                className="form-select mb-3"
                                                value={agentForm.experience}
                                                onChange={e => setAgentForm({ ...agentForm, experience: e.target.value })}
                                            >
                                                <option value="">Experience *</option>
                                                <option value="0-1">0–1 Years</option>
                                                <option value="1-3">1–3 Years</option>
                                                <option value="3-5">3–5 Years</option>
                                                <option value="5+">5+ Years</option>
                                            </select>

                                            <div className="d-flex gap-2">
                                                <button
                                                    className="btn btn-success w-100"
                                                    disabled={leadLoading}
                                                    onClick={async () => {
                                                        if (leadMobile.length !== 10) {
                                                            return Swal.fire({
                                                                icon: "warning",
                                                                title: "Invalid number",
                                                                text: "Please enter 10 digit mobile number",
                                                                timer: 2000,
                                                                showConfirmButton: false
                                                            });
                                                        }

                                                        const id = await createLead("continue");

                                                        if (!id) return;

                                                        // 🔥 IMPORTANT ORDER
                                                        setShowLeadsModal(false);

                                                        setTimeout(() => {
                                                            navigate("/leads");
                                                        }, 100);
                                                    }}
                                                >
                                                    {leadLoading ? "Please wait..." : "Continue"}
                                                </button>



                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {showLeadsModal && (
                            <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,.5)" }}>
                                <div className="modal-dialog modal-dialog-centered">
                                    <div className="modal-content rounded-4">

                                        <div className="modal-header" style={{
                                            background: "linear-gradient(135deg,rgb(192 223 248))",
                                        }}>
                                            <h5 className="modal-title">Get Leads</h5>
                                            <button
                                                className="btn-close"
                                                onClick={() => setShowLeadsModal(false)}
                                            />
                                        </div>

                                        <div className="modal-body">

                                            {/* STEP 1 */}
                                            {leadStep === 1 && (
                                                <>
                                                    <p className="small text-muted">Enter your mobile number</p>

                                                    <div className="d-flex align-items-center border rounded-3 overflow-hidden mb-3">
                                                        <div className="d-flex align-items-center px-3 gap-2 border-end">
                                                            <img
                                                                src="/np.svg"
                                                                alt="Nepal"
                                                                width="22"
                                                                height="16"
                                                            />
                                                            <span className="fw-semibold">+977</span>
                                                        </div>
                                                        <input
                                                            className="form-control border-0"
                                                            placeholder="Mobile number"
                                                            maxLength={10}
                                                            value={leadMobile}
                                                            onChange={(e) => setLeadMobile(e.target.value.replace(/\D/g, ""))}
                                                        />
                                                    </div>

                                                    <button
                                                        className="btn btn-success w-100"
                                                        disabled={leadLoading}
                                                        onClick={() => {
                                                            if (leadMobile.length !== 10)
                                                                return Swal.fire("Invalid number", "Enter 10 digit number", "warning");
                                                            createLead();
                                                        }}
                                                    >
                                                        {leadLoading ? "Please wait..." : "Continue"}
                                                    </button>
                                                </>
                                            )}

                                            {/* STEP 2 */}
                                            {leadStep === 2 && (
                                                <>
                                                    <p className="small text-muted">Tell us your requirement</p>

                                                    <textarea
                                                        className="form-control mb-3"
                                                        rows="3"
                                                        placeholder="Example: Need electrician for home wiring"
                                                        value={leadRequirement}
                                                        onChange={(e) => setLeadRequirement(e.target.value)}
                                                    />

                                                    <button
                                                        className="btn btn-success w-100"
                                                        disabled={leadLoading}
                                                        onClick={() => {
                                                            if (!leadRequirement)
                                                                return Swal.fire("Required", "Please enter requirement", "warning");
                                                            submitRequirement();
                                                        }}
                                                    >
                                                        {leadLoading ? "Submitting..." : "Submit"}
                                                    </button>
                                                </>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {showAdModal && (
                            <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,.5)" }}>
                                <div className="modal-dialog modal-dialog-centered">
                                    <div className="modal-content rounded-4">

                                        {/* HEADER */}
                                        <div
                                            className="modal-header"
                                            style={{ background: "#ddf0ff" }}
                                        >
                                            <h5 className="modal-title">Advertise Your Business</h5>
                                            <button
                                                className="btn-close"
                                                onClick={() => setShowAdModal(false)}
                                            />
                                        </div>

                                        {/* BODY */}
                                        <div className="modal-body">

                                            <input
                                                className="form-control mb-2"
                                                placeholder="Business Name *"
                                                value={adForm.business_name}
                                                onChange={(e) =>
                                                    setAdForm({ ...adForm, business_name: e.target.value })
                                                }
                                            />

                                            <input
                                                className="form-control mb-2"
                                                placeholder="Mobile Number *"
                                                maxLength={10}
                                                value={adForm.mobile}
                                                onChange={(e) =>
                                                    setAdForm({ ...adForm, mobile: e.target.value.replace(/\D/g, "") })
                                                }
                                            />

                                            <input
                                                className="form-control mb-2"
                                                placeholder="City *"
                                                value={adForm.city}
                                                onChange={(e) =>
                                                    setAdForm({ ...adForm, city: e.target.value })
                                                }
                                            />

                                            <input
                                                className="form-control mb-2"
                                                placeholder="Category (optional)"
                                                value={adForm.category}
                                                onChange={(e) =>
                                                    setAdForm({ ...adForm, category: e.target.value })
                                                }
                                            />

                                            <select
                                                className="form-select mb-3"
                                                value={adForm.budget_range}
                                                onChange={(e) =>
                                                    setAdForm({ ...adForm, budget_range: e.target.value })
                                                }
                                            >
                                                <option value="">Budget Range (optional)</option>
                                                <option value="5k-10k">₹5k – ₹10k</option>
                                                <option value="10k-25k">₹10k – ₹25k</option>
                                                <option value="25k+">₹25k+</option>
                                            </select>

                                            {/* SUBMIT BUTTON */}
                                            <button
                                                className="btn btn-success w-100"
                                                disabled={adLoading}
                                                onClick={submitAdvertisement}
                                            >
                                                {adLoading ? "Submitting..." : "Submit Advertisement"}
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </nav >

            {/* Internal CSS */}
            < style > {`
                .nav-text {
                    font-size: 15px;
                    font-weight: 500;
                    margin-right: 20px;
                }

                .nav-link:hover {
                    color: #0d6efd !important;
                }
            `}</style >
            <style>{`
                .dropdown-menu {
                    border-radius: 8px;
                }

                .dropdown-item:hover {
                    background: #f2f5ff;
                }

                .btn-light {
                    background: #fff;
                    border-radius: 6px;
                }
                    .user-btn {
                    background: transparent !important;
                    border: none !important;
                    outline: none !important;
                    box-shadow: none !important;
                    padding: 6px 12px;
                    display: flex;
                    align-items: center;
                    color: var(--bs-primary) !important;
                    font-weight: 500;
                }

                .user-btn i {
                    color: var(--bs-primary) !important;
                }

                /* Remove grey/blue hover & active effects */
                .user-btn:hover,
                .user-btn:focus,
                .user-btn:active,
                .user-btn.show {
                    background: transparent !important;
                    border: none !important;
                    outline: none !important;
                    box-shadow: none !important;
                    color: var(--bs-primary) !important;
                }
                    /* GLOBAL FONT SETTINGS */
body, .navbar, .nav-link, .dropdown-menu, .btn {
    font-family: "Poppins", sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    
}
.fb{

color: #fff !important; }

/* NAV ITEMS SMALL + RIGHT ALIGN */
#mainNavbar .navbar-nav {
    margin-left: auto !important;  /* ← moves all 4 nav items to RIGHT */
    margin-right: 0 !important;
}

/* Reduce gap between items slightly */
#mainNavbar .nav-item {
    padding-left: 6px !important;   /* reduced from px-2 */
    padding-right: 6px !important;
}

/* BUTTONS SMALL LIKE JustDial */
.navbar .btn {
    padding: 4px 10px !important;
    font-size: 13px !important;
    border-radius: 6px !important;
}

/* Free Listing button small badge */
.navbar .badge {
    font-size: 8px !important;
    padding: 2px 4px !important;
}

/* Logo gap reduce */
.navbar-brand img {
    margin-right: 20px !important;
}

/* Talk to us icon spacing reduce */
.btn i {
    margin-right: 4px !important;
}
/* ===== JUSTDIAL TALK TO US ===== */

.jd-phone-box {
    display: flex;
    align-items: center;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 8px 10px;
    background: #fafafa;
}

.jd-flag {
    font-size: 18px;
    margin-right: 6px;
}

.jd-code {
    font-size: 13px;
    color: #555;
    margin-right: 8px;
}

.jd-phone-input {
    border: none;
    outline: none;
    flex: 1;
    font-size: 14px;
    background: transparent;
}

.jd-call-btn {
    background: #16a34a;
    color: #fff;
    border-radius: 8px;
    padding: 10px;
    font-size: 14px;
}

.jd-call-btn:hover {
    background: #15803d;
}

/* Modal faint look */
.modal-content {
    border: none !important;
    box-shadow: 0 12px 30px rgba(0,0,0,.12);
}

.modal-body small {
    color: #6b7280;
}
.agent-avatar {
    width: 72px;
    height: 72px;
    border-radius: 6px;   /* ✅ exactly as requested */
    object-fit: cover;
    border: 1px solid #e5e7eb;
    background: #f8fafc;
}
.agent-skeleton {
    width: 72px;
    height: 72px;
    border-radius: 6px;
    background: linear-gradient(
        90deg,
        #f0f0f0 25%,
        #e0e0e0 37%,
        #f0f0f0 63%
    );
    animation: shimmer 1.4s infinite;
}

@keyframes shimmer {
    0% { background-position: -200px 0; }
    100% { background-position: 200px 0; }
}

.agent-avatar.hide {
    display: none;
}

.agent-avatar.show {
    display: block;
}
/* ===== MODERN TALK TO US ===== */

.phone-box {
  display: flex;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #fafafa;
}

.country-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #fff;
  border: none;
  border-right: 1px solid #e5e7eb;
  cursor: pointer;
  font-size: 14px;
}

.country-btn .flag {
  font-size: 16px;
}

.country-btn .code {
  font-weight: 500;
}

.phone-input {
  border: none;
  outline: none;
  padding: 10px;
  flex: 1;
  font-size: 14px;
  background: transparent;
}

.country-menu {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  margin-top: 6px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
}

.country-menu div {
  padding: 10px 14px;
  cursor: pointer;
  font-size: 14px;
}

.country-menu div:hover {
  background: #f1f5ff;
}

.call-cta {
  background: linear-gradient(135deg, #16a34a, #22c55e);
  color: #fff;
  border-radius: 10px;
  padding: 12px;
  font-size: 15px;
  font-weight: 600;
  border: none;
}

.call-cta:hover {
  background: linear-gradient(135deg, #15803d, #16a34a);
}

.phone-wrapper {
  position: relative;
}
.phone-wrapper {
  position: relative;
}
.flag {
  font-family: "Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol",sans-serif;
  font-size: 18px;
  line-height: 1;
}
.phone-box {
  display: flex;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #ffffff;
}

.country-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  background: #f9fafb;
  border: none;
  border-right: 1px solid #e5e7eb;
  cursor: pointer;
  white-space: nowrap;
}

.country-btn:hover {
  background: #eef2ff;
}

.phone-input {
  flex: 1;
  border: none !important;
  outline: none !important;
  padding: 10px;
  font-size: 14px;
}

.country-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  z-index: 9999;
  margin-top: 6px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
}


            `}</style>

        </>
    );
}

export default Navbar;
